import { ItandiHeader } from "@itandi/brand-ui/ItandiHeader";
import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import { useRouter } from "next/router";
import type { ComponentProps } from "react";
import { useCallback } from "react";
import { useAccounts } from "../hooks/useAccounts";
import { useDeleteItandiAccountSessions } from "../hooks/useItandiAccountSessions";
import { useDeleteItandiAccountUserSessions } from "../hooks/useItandiAccountUserSessions";
import type { ItandiAccountSession } from "../models/ItandiAccountSession";
import type { ItandiAccounUsertSession } from "../models/ItandiAccountUserSession";
import { paths } from "../utils/paths";

type Props = DeepReadonly<{
	account: ItandiAccountSession;
	user: ItandiAccounUsertSession;
}>;

export function Header({ account, user }: Props) {
	const router = useRouter();
	const { data: stores } = useAccounts();
	const isActivePage = useCallback(
		(path: string): boolean =>
			path === "/" ? router.pathname === "/" : router.pathname.includes(path),
		[router.pathname]
	);

	const deleteItandiAccountSessions = useDeleteItandiAccountSessions();
	const deleteItandiAccountUserSessions = useDeleteItandiAccountUserSessions();

	const handleLogout = async () => {
		await deleteItandiAccountSessions.mutateAsync();
		router.push(`/contracts`);
	};
	const handleLogoutStaff = async () => {
		await deleteItandiAccountUserSessions.mutateAsync();
		router.push(`/contracts`);
	};
	const filteredAccounts = stores
		? stores.map((store) => ({
				authId: store.authId,
				name: store.name
			}))
		: [];

	const menus: ComponentProps<typeof ItandiHeader>["menus"] = [
		{
			active: isActivePage(paths.inspectionList),
			as: Link,
			href: paths.inspectionList,
			kind: "link",
			label: "案件一覧"
		},
		{
			active: isActivePage(paths.contractList),
			as: Link,
			href: paths.contractList,
			kind: "link",
			label: "建物管理契約"
		},
		{
			active: isActivePage(paths.vendorList),
			as: Link,
			href: paths.vendorList,
			kind: "link",
			label: "取引先"
		},
		{
			active:
				isActivePage(paths.roleList) || isActivePage(paths.todoTemplateList),
			items: [
				{
					as: Link,
					href: paths.roleList,
					label: "担当者とロール"
				},
				{
					as: Link,
					href: paths.todoTemplateList,
					label: "TODOテンプレート"
				}
			],
			kind: "list",
			label: "設定"
		},
		{
			href: "https://itandibb.support.itandi.co.jp/hc/ja",
			isExternalLink: true,
			kind: "link",
			label: "ヘルプ"
		}
	];

	return (
		<ItandiHeader
			changeableStores={filteredAccounts}
			changeStaff={handleLogoutStaff}
			itandiAccount={{
				companyName: account.companyName,
				storeName: account.storeName
			}}
			logout={handleLogout}
			menus={menus}
			productCode="tk"
			productMenus={account.productParams}
			staffAccount={user}
		/>
	);
}
